import React from 'react';
import BaseCell from './BaseCell';
import { formatDateTime } from 'shared/../helpers/date';

const defaultFormatMethod = (date, ignoreSeconds) => formatDateTime(date, { ignoreSeconds });
const formatWithoutTZ = (date, ignoreSeconds) => formatDateTime(date, { ignoreTimezone: true, ignoreSeconds });

const DateTimeCell = ({
  date, formatMethod = defaultFormatMethod, ignoreTimezone = false, ignoreSeconds = true, ...props
}) => {
  // eslint-disable-next-line no-nested-ternary
  const displayValue = date
    ? (!ignoreTimezone ? formatMethod(date, ignoreSeconds) : formatWithoutTZ(date, ignoreSeconds)) : null;
  return (
    <BaseCell {...props}>{displayValue}</BaseCell>
  );
};

export default DateTimeCell;
